import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { clearAuthSession, setAuthSession } from "./auth";
import type { UserInfo } from "./models";

export const authTokenAtom = atomWithStorage<string | null>("auth_token", null);
export const userAtom = atomWithStorage<UserInfo | null>("auth_user", null);
export const isAuthenticatedAtom = atom((get) => !!get(authTokenAtom));

export const setAuthAtom = atom(
  null,
  (_, set, { token, user }: { token: string; user: UserInfo }) => {
    setAuthSession({
      access_token: token,
      refresh_token: "", // This will be set by the auth hook
    });
    set(authTokenAtom, token);
    set(userAtom, user);
  }
);

export const clearAuthAtom = atom(null, (_, set) => {
  clearAuthSession();
  set(authTokenAtom, null);
  set(userAtom, null);
});
